import { formatPhone } from '@/modules/ui';
import type { User } from '@/types/user';

import type { MemberContactFormValues } from '../schema/memberContactSchema';

/**
 * Prefill the form from the persisted user/profile — the source of truth. Address
 * is split across the two objects: state/ZIP/phone on the User, street/city on the
 * customer profile. Phone is re-masked for display.
 *
 * No draft fallback: values entered earlier in onboarding are already persisted
 * (phone is submitted at account creation, not held as a draft), and the only
 * draft ZIP is the *eligibility* ZIP, not the member's mailing address. The
 * screen refreshes the user on mount before calling this, so it reflects the
 * latest saved data.
 */
export function mapUserToFormValues(user: User | undefined): MemberContactFormValues {
  const profile = user?.customerProfile;
  return {
    phone: formatPhone(user?.phone ?? ''),
    addressLine1: profile?.addressFirstLine ?? '',
    addressLine2: profile?.addressSecondLine ?? '',
    city: profile?.addressCity ?? '',
    state: user?.state ?? '',
    zip: user?.zipCode ?? '',
  };
}
